@if(loader){
  <app-loader></app-loader>
}

  <p-card> 
      <div class="">

          <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
            <div class="flex align-items-center">
              <p-button label="New" class="p-button-outlined" icon="pi pi-plus-circle" (click)="CreateCustomer()" size="small"
                pTooltip="Create Customer"></p-button>
          
          
              <div class="flex align-items-center ml-3">
                <span class="p-input-icon-left">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder" class=" p-inputtext-sm"
                    (keyup.enter)="searchCustomer()" style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" />
                </span>
                <p-button icon="pi pi-search" (onClick)="searchCustomer()"
                  [style]="{'margin': '5px 5px 5px 5px', 'height': '35px', 'line-height': '50px'}" [raised]="true"
                  [size]="'small'" severity="info"></p-button>
              </div>
          
              <p-button *ngIf="selectedCustomer && selectedCustomer.length == 1" label="Edit" class="ml-2" icon="pi pi-user-edit"
                (click)="editCustomer()" size="small" severity="secondary"></p-button>
              <p-button *ngIf="selectedCustomer && selectedCustomer.length > 0" label="Delete" class="ml-2" icon="pi pi-trash"
                (click)="deleteCustomer()" size="small" severity="danger"></p-button>
            </div>

        <h2 class="page-title-center">Customer List</h2>

          
            <div class="flex">
              <div class="flex align-items-center">
                <p-button icon="pi pi-refresh" size="small" (click)="refreshData()" [rounded]="true" severity="info"></p-button>
              </div>
            </div>
          </div>

            <p-table #dt1 [value]="customers" [scrollable]="true" styleClass="p-datatable-striped"  class="w-full m-5" styleClass="p-datatable-sm " scrollHeight="613px"
                  [paginator]="true" [rows]="10" [globalFilterFields]="['customerCode','customerName','mobile','email','address.addressLine1','address.state','address.city']" (onPage)="loadcustomers($event)" [(selection)]="selectedCustomer"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10 ,15, 20]" [rowHover]="true" [selectionPageOnly]="true">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 4rem">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                      </th>
                      <!-- <th>Image</th> -->
                      <th>Customer Code</th>
                      <th>Customer Name</th>
                      <th>Mobile</th>
                      <th>Email</th>
                      <th>Address</th>
                      <th>City</th>
                      <th>State</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-customer>
                    <tr>
                      <td>
                        <p-tableCheckbox [value]="customer"></p-tableCheckbox>
                      </td>
                      <!-- <td>
                        <p-image
                          [src]="customer.customerImage"
                          [alt]="customer.customerImage ? 'Customer Image' : 'No Image Available'"
                          width="30"
                          [preview]="true">
                        </p-image>
                      </td> -->
                      <td class="text-blue-500 underline" style="cursor: pointer;" (click)="editCustomer(customer.customerId)">
                        {{customer.customerCode}}
                      </td>
                      <td>{{customer.customerName}}</td>
                      <td>{{customer.mobile}}</td>
                      <td>{{customer.email}}</td>
                      <td>{{customer.address?.addressLine1}}</td>
                      <td>{{customer.address?.city}}</td>
                      <td>{{customer.address?.state}}</td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="8">No Records found.</td>
                    </tr>
                </ng-template>
          </p-table>
      </div>
      </p-card>

  <p-toast></p-toast>
  <p-confirmDialog></p-confirmDialog>